export default __webpack_public_path__ + "static/media/linkWhite.4003c6b9.svg";